import styled from 'styled-components';
import {
    GeneralButton, ContentBodyContainer, GridCol, FlexGridSixth
} from '../../../components/Common/CommonLayout';
import { ColorName } from "../../../components/Variables";

const Container = styled(ContentBodyContainer)`
    &.for-search{
        position: relative;
        display: flex;
        width: 400px;
        margin: 2em 0;
    }
    color: ${ColorName.chathamsBlueDark};
    & .search-bar{
        width: 100%;
        border: 1px solid ${ColorName.chathamsBlueDark};
        outline: none;
        padding: 5px;
    }
    & i{
        position: absolute;
        right: 10px;
        top: 5px;
        cursor: pointer;
    }
    &.item{
        padding: 10px 0;
        border-bottom: 1px solid ${ColorName.chathamsBlueDark};
    }
    & .container-button{
        display: flex;
        justify-content: flex-end;
    }
`;

const Button = styled(GeneralButton)`
    margin-right: 1em;
    border: 1px solid ${ColorName.chathamsBlueDark};
    margin-top: 1em;
`;

const FlexGridSixthTemplate = styled(FlexGridSixth)`
    &.container-button {
        margin-top: 2em;
    }
    margin: 0 1em;
    & .border-top{
        border-top: 1px solid ${ColorName.chathamsBlueDark};
    }
    & .order-2{
        order: 2;
        padding-left: 2em;
    }
    & .order-1{
        padding-right: 2em;
    }
    @media (max-width: 768px) {
        flex-direction: column;
        & .order-2{
            padding: 0;
        }
        & .order-1{
            padding: 0;
        }
        & .reverse{
            order: 2;
        }
    }
`;
const GridColHomepage = styled(GridCol)`
    & .description{
        margin-top: 2em;
    }
    & ul{
        list-style: none;
        padding-inline-start: 0;
        & li{
            display: flex;
            flex-direction: column;
            padding-bottom: 1em;
        }
        & .title{
            color: ${ColorName.fern};
            font-size: 1.5em;
            font-weight: 600;
        }
        & .description{
            color: ${ColorName.chathamsBlueDark};
            font-size: 0.8em;
        }
    }
    & .image-invite{
        width: 100%;
        border: 1px solid ${ColorName.chathamsBlueDark};
        // border-top: none;
    }
    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Title = styled.div`
    font-size: 2.5em;
    font-weight: 600;
    text-align: left;
    & .content{
        font-weight: 200;
    }
`;
const GeneralButtonUser = styled(GeneralButton)`
    font-weight: 500;
    font-size: 1em;
    &:first-child{
        margin-right: 0.5em;
    }
    min-width: unset;
    padding: 0.2em 0.8em;
    border: 1px solid ${ColorName.chathamsBlue};
`;

export {
    Container,
    GridColHomepage,
    Title,
    FlexGridSixthTemplate,
    Button,
    GeneralButtonUser
};
